import { createBrowserHistory } from 'history';
import { baseUrl } from '../config';

export default createBrowserHistory({ basename: baseUrl });
